<template>
  <div id="page-product-bundle-details">
    <product-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Create Product Bundle"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'productBundles.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            :disabled="loading"
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductForm from "@/views/pages/product-bundles/ProductBundleForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';

export default {
  name: "ProductBundleCreate",
  components: {
    ProductForm
  },
  mixins: [ NotificationMixin, SaveModelMixin, CanAccessMixin ],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const multiReferences = [
        {
          array: 'main_raters',
          key: ['Product_FK', 'ORABundle_FK']
        },
      ];

      if (params.main_raters.length) {
        params.main_raters.forEach(main_raters => {
          if (main_raters.cross_selling.length) {
            this.setMultiReferences(
              [
                {
                  array: 'cross_selling',
                  key: ['Product_FK'],
                },
              ],
              main_raters
            );
          }
        });
      }

      this.setReferences(['ORABundle_FK'], params);
      this.setMultiReferences(multiReferences, params);

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      try {
        const { data } = await this.$api.productBundles.create(params);
        this.notifySuccess('Bundle created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Bundle failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
